<template>
<div class="chapter">
<div class="inner_page">
<div class="fmtitle"><span><a id="pagevi"></a><a id="pagevii"></a><b>Contents</b></span></div>
<div class="image2"><span><img alt="image" src="images/common.png"/></span></div>
<table>
<tbody><tr>
<td valign="top"></td>
<td valign="top"><div class="toc"><span><a href="#/map#map" id="rmap">List of Maps</a></span></div></td>
</tr><tr>
<td valign="top"></td>
<td valign="top"><div class="toc"><span><a href="#/preface#pre" id="rpre">Preface</a></span></div></td>
</tr><tr>
<td valign="top"><div class="toc1"><span><a href="#/part1#p1" id="rp1"><b>Part One: Starting Premises</b></a></span></div></td>
<td valign="top"><div class="toc2"><span><a href="#/ch01#c1" id="rc1">1. A Long View</a></span></div></td>
</tr><tr>
<td valign="top"></td>
<td valign="top"><div class="toc"><span><a href="#/ch02#c2" id="rc2">2. Ideas and Ideology</a></span></div></td>
</tr><tr>
<td valign="top"><div class="toc1"><span><span href="#/part2#p2" id="rp2" title="Link target outside of Sample"><b>Part Two: The States</b></span></span></div></td>
<td valign="top"><div class="toc2"><span><span href="#/ch03#c3" id="rc3" title="Link target outside of Sample">3. Mexico</span></span></div></td>
</tr><tr>
<td valign="top"></td>
<td valign="top"><div class="toc"><span><span href="#/ch04#c4" id="rc4" title="Link target outside of Sample">4. United States</span></span></div></td>
</tr><tr>
<td valign="top"></td>
<td valign="top"><div class="toc"><span><span href="#/ch05#c5" id="rc5" title="Link target outside of Sample">5. Canada</span></span></div></td>
</tr><tr>
<td valign="top"></td>
<td valign="top"><div class="toc"><span><span href="#/ch06#c6" id="rc6" title="Link target outside of Sample">6. Australia</span></span></div></td>
</tr><tr>
<td valign="top"><div class="toc1"><span><span href="#/part3#p3" id="rp3" title="Link target outside of Sample"><b>Part Three: Comparisons</b></span></span></div></td>
<td valign="top"><div class="toc2"><span><span href="#/ch07#c7" id="rc7" title="Link target outside of Sample">7. Other States and Indigenous Peoples</span></span></div></td>
</tr><tr>
<td valign="top"></td>
<td valign="top"><div class="toc"><span><span href="#/ch08#c8" id="rc8" title="Link target outside of Sample">8. Conclusions from Cases Compared</span></span></div></td>
</tr><tr>
<td valign="top"></td>
<td valign="top"><div class="toc2"><span><span href="#/references#ref" id="rref" title="Link target outside of Sample">References Cited</span></span></div></td>
</tr><tr>
<td valign="top"></td>
<td valign="top"><div class="toc"><span><span href="#/recommended#rec" id="rrec" title="Link target outside of Sample">Recommended Sources on Indigenous Groups</span></span></div></td>
</tr><tr>
<td valign="top"></td>
<td valign="top"><div class="toc"><span><span href="#/index#ind" id="rind" title="Link target outside of Sample">Index</span></span></div></td>
</tr></tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?e2e5aa14